import { ReactNode } from 'react'
import {
  OptionsObject,
  SnackbarKey,
  closeSnackbar,
  enqueueSnackbar,
} from 'notistack'
import { AlertColor, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Nullable } from '$models'

/**
 * How long a toast stays before auto-hiding. Shared by the notistack provider (non-collapsable
 * toasts) and LoadedSnackbar's own timer (collapsed toasts) so both behave the same.
 */
export const SNACKBAR_AUTO_HIDE_MS = 6000

declare module 'notistack' {
  interface VariantOverrides {
    //Custom variant name
    loadedSnackbar: {
      //Custom properties sent to the variant
      details?: ReactNode[]
      severity?: AlertColor
      errorId?: string
      errorCode?: number
    }
  }
}

export const enqueueLoadedSnackbar = (
  message: Nullable<string>,
  severity: AlertColor,
  details: string[] = [],
  errorId?: string,
  errorCode?: number,
  options?: OptionsObject
) => {
  if (!message) return

  // Collapsable toasts (id, code or details) persist so they don't vanish while being read;
  // LoadedSnackbar closes them on dismiss or collapse.
  const isCollapsable = Boolean(errorId ?? errorCode ?? details.length)

  enqueueSnackbar(message, {
    variant: 'loadedSnackbar',
    severity: severity,
    details: details,
    errorId: errorId,
    errorCode: errorCode,
    persist: isCollapsable,
    ...options,
  })
}

export const Action = (snackbarId: SnackbarKey | undefined): ReactNode => (
  <IconButton
    onClick={() => {
      closeSnackbar(snackbarId)
    }}
  >
    <CloseIcon />
  </IconButton>
)
